import SilAccommodation from "./SilAccommodation.container";

export default SilAccommodation;
